import { extractEmailDomain } from "./generic-email-domains";

export const STAFF_EMAIL_DOMAIN = "repackify.com";

export function isStaffEmail(email: string | undefined | null): boolean {
  if (!email) return false;
  return extractEmailDomain(email) === STAFF_EMAIL_DOMAIN;
}

export function isRepackifyOwnedEmail(email: string | undefined | null): boolean {
  if (!email) return false;
  const domain = extractEmailDomain(email);
  if (domain === null) return false;
  return (
    domain === STAFF_EMAIL_DOMAIN || domain.endsWith(`.${STAFF_EMAIL_DOMAIN}`)
  );
}
